import { render, staticRenderFns } from "./invite-record.vue?vue&type=template&id=8fb42d1e&scoped=true&"
import script from "./invite-record.vue?vue&type=script&lang=js&"
export * from "./invite-record.vue?vue&type=script&lang=js&"
import style0 from "./invite-record.vue?vue&type=style&index=0&id=8fb42d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb42d1e",
  null
  
)

export default component.exports